import { LogView } from '@lemoncloud/codes-backend-api';

import type { ListResult, Params } from '@codes/shared';
import { webCore } from '@codes/web-core';

const BACKEND_ENDPOINT = import.meta.env.VITE_OAUTH_ENDPOINT.toLowerCase();

export const fetchLogs = async (params: Params): Promise<ListResult<LogView>> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'GET',
            baseURL: `${BACKEND_ENDPOINT}/mocks/logs`,
        })
        .setParams(params)
        .execute<ListResult<LogView>>();

    return { ...data };
};
